import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-banner管理",
  "use": "icon-banner管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-banner管理\">\n<path d=\"M9 24C9 17.9249 13.9249 13 20 13H140C146.075 13 151 17.9249 151 24V136C151 142.075 146.075 147 140 147H20C13.9249 147 9 142.075 9 136V24Z\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M8.80005 120L52.3821 95.5224C56.3709 93.2821 61.128 92.8565 65.4512 94.3531L92.9647 103.877C97.5692 105.471 102.649 104.88 106.764 102.272L152 73.6\" stroke-width=\"10\" stroke-linecap=\"round\" />\n<circle cx=\"50.3999\" cy=\"52\" r=\"15\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/banner管理.svg
// module id = 967m
// module chunks = 26